<div class="container-fluid">
  <div class="row">
    <div class="row">
      <!-- Page Title Box -->
      <div class="col-lg-4">
        <h4 class="mb-0 font-size-18 pt-2">Welcome To Ripple Dashboard!</h4>
      </div>

      <!-- Project Start Date and Refresh Button -->
      <div class="col-lg-8 d-flex justify-content-end align-items-end">
        <!-- Project Start Date -->
        <h4 class="font-size-16">
          Billing Initiated Date:
          {{
            billingInitiatedOn != null
              ? (billingInitiatedOn | date: "dd MMM yyyy")
              : ""
          }}
        </h4>

        <!-- Refresh Button -->
        <button
          class="btn btn-primary ml-87"
          kendoTooltip
          (click)="refreshDashboard()"
          title="Clicking the 'Refresh' button will update the dashboard with the most recent information"
          [position]="'left'"
        >
          <span><i class="fas fa-redo"></i> </span>&nbsp;&nbsp;Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div *ngIf="isWalletEnabled" class="row">
      <div class="col-lg-4">
        <div class="position-relative d-flex justify-content-center">
          <div class="prepaid-dashboard-image">
            <img src="../../../assets/images/wallet-balance.png" />
          </div>
        </div>
        <div class="card mini-stats-wid mini-stats-wid-dashboard">
          <div
            class="card-details d-flex justify-content-center text-center mb-3"
          >
            <div (click)="gotoWalletHistoryreport()">
              <p class="mb-0 mb-2 font-size-18 cursor-pointer">
                Wallet Deducted Amount &nbsp;<span
                  class="text-danger font-size-10"
                  >(Till Date)</span
                >
              </p>

              <h4
                class="font-weight-bold-dashboard text-truncate cursor-pointer mb-0 align-items-center"
              >
                <!--  <span>₹</span> -->
                {{
                  deductedWalletBalance != undefined
                    ? (deductedWalletBalance
                      | currency: "INR" : "symbol" : "1.2-2")
                    : ""
                }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="position-relative d-flex justify-content-center">
          <div class="prepaid-dashboard-image">
            <img src="../../../assets/images/current-balance.png" />
          </div>
        </div>
        <div class="card mini-stats-wid mini-stats-wid-dashboard">
          <div
            class="card-details d-flex justify-content-center text-center mb-3"
          >
            <div (click)="goToWallet()" class="text-center">
              <p class="mb-0 mb-2 font-size-18 cursor-pointer">
                Current Balance &nbsp;<span class="text-danger font-size-10"
                  >(Till Date)</span
                >
              </p>
              <h4
                class="font-weight-bold-dashboard align-items-center text-truncate mb-0 cursor-pointer"
              >
                <!-- <span>₹</span> -->
                {{
                  currentWalletBalance | currency: "INR" : "symbol" : "1.2-2"
                }}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="position-relative d-flex justify-content-center">
          <div class="prepaid-dashboard-image">
            <img
              style="height: 55px"
              src="../../../assets/images/money-currency_16195169.svg"
            />
          </div>
        </div>
        <div class="card mini-stats-wid mini-stats-wid-dashboard">
            <div
              class="card-details d-flex justify-content-center text-center mb-3"
            >
              <div (click)="goToWalletReport()">
                <p class="mb-0 mb-2 font-size-18 cursor-pointer">
                  Total Wallet Recharge &nbsp;<span
                    class="text-danger font-size-10"
                    >(Till Date)</span
                  >
                </p>
                <h4
                  class="font-weight-bold-dashboard text-truncate mb-0 cursor-pointer"
                >
                  <!-- <span>₹</span> -->
                  {{
                    totalWalletRecharge | currency: "INR" : "symbol" : "1.2-2"
                  }}
                </h4>
              </div>
            </div>
        </div>
      </div>
    </div>

    @if (billingType == BillingType.PREPAID) {
      <div class="row mt-2">
        <div class="col-xl-4" *ngFor="let item of prepaidSummary">
          <div
            class="card cursor-pointer"
            [style.background]="item.background"
            (click)="prepaidbillStatus(item)"
          >
            <div class="d-flex justify-content-start py-3  align-items-center">
              <!--  <span  *ngIf="item.label == 'Total Bills'" class="fa fa-info-circle cursor-pointer position-absolute top-0 end-0 mt-2 me-2" kendoTooltip [title]="
                ' Last six months'
              "></span> -->
              <span
                class="position-absolute top-10 end-0 mt-2 me-2 required"
                *ngIf="item.label === 'Total Bills' || item.label === 'Revenue'"
                ><small>*last 6 months</small></span
              >
              <img [src]="item.img" class="w-20 mx-1" />

              <div
                class="text-center border-right pr-30"
                *ngIf="item.label == 'Total Bills'"
              >
                <p class="mb-0">{{ item.label }}</p>
                <h4 class="mb-0">{{ item.value }}</h4>
              </div>
              <div class="text-center" *ngIf="item.label !== 'Total Bills'">
                <p class="mb-0 ml-10 ">{{ item.labelAmount }}</p>
                <h4 class="mb-0 ml-10 pt-1">
                  {{ item.value | currency: "INR" : "symbol" : "1.2-2" }}
                </h4>
              </div>

              <div *ngIf="item.label == 'Total Bills'">
                <p class="mb-0 ml-10 pt-1">{{ item.labelAmount }}</p>
                <h4
                  class="mb-0 text-truncate w-9 ml-10 px-1"
                  kendoTooltip
                  title="{{ item.amount }}"
                >
                  {{ item.amount | currency: "INR" : "symbol" : "1.2-2" }}
                </h4>
              </div>
            </div>

            <div *ngIf="prepiadSummaryLoader" class="chart-loader">
              <div class="spinner"></div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="row mb-4">
      <div class="d-flex justify-content-end align-items-center">
        <div class="me-2" *ngIf="dateRange">
          <div
            class="position-relative me-2"
            *ngIf="dateRange"
            style="width: 238px"
          >
            <input
              type="text"
              class="form-control date"
              [value]="
                filterProjectBillDates
                  ? formatDateRange(filterProjectBillDates)
                  : ''
              "
              placeholder="Select Date"
              name="daterange"
              autocomplete="off"
              bsDaterangepicker
              [bsConfig]="datePickerConfig"
              [(bsValue)]="filterProjectBillDates"
              (bsValueChange)="onDateRangeSelected($event)"
            />
            <span
              class="bx bx-calendar inputIcon"
              (click)="openCalendar()"
            ></span>
            <span
              class="bx bx-x inputIcon clear-icon"
              *ngIf="filterProjectBillDates"
              (click)="clearDate()"
            ></span>
          </div>

          <!-- <input type="text" class="form-control date" placeholder="Select Date" name="daterange" autocomplete="off"
            bsDaterangepicker [bsConfig]="datePickerConfig" (bsValueChange)="onDateRangeSelected($event)" /> -->
        </div>
        <div class="d-flex">
          <div class="me-2">
            <ng-select
              [items]="months"
              (change)="selectionChange($event)"
              id="billingType"
              placeholder="Select Month"
              [(ngModel)]="selectedRange"
              [multiple]="false"
              [clearable]="false"
              [deselectOnClick]="false"
            ></ng-select>
          </div>
          <!-- <div>
            <ng-select [items]="projectUtlityList" [clearable]="false" [(ngModel)]="consuptionSelectedUtility"
              placeholder="Select Utility" (change)="consuprtionUtilitiesChange($event)" id="billingType"
              [multiple]=" false" [deselectOnClick]="false" [clearable]="false" bindValue="id"
              bindLabel="name"></ng-select>
          </div> -->
        </div>
      </div>
    </div>
    @if (billingType == BillingType.POSTPAID) {
      <div class="row mt-3">
        <div class="col-xl-4" *ngFor="let item of billSummary">
          <div
            class="card cursor-pointer"
            [style.background]="item.background"
            (click)="billStatus(item)"
          >
            <div class="d-flex justify-content-between p-3 align-items-center">
              <span
                class="fa fa-info-circle cursor-pointer position-absolute top-0 end-0 mt-2 me-2"
                kendoTooltip
                [title]="
                  item.label +
                  ' includes the total count for bills, manual bills, and adhoc bills'
                "
              >
              </span>
              <img [src]="item.img" class="w-20" />
              <div class="text-center border-right pr-30">
                <p class="mb-0">{{ item.label }}</p>
                <h4 class="mb-0">{{ item.value }}</h4>
              </div>
              <!--  <span class="fa fa-info-circle cursor-pointer" style="float: right" kendoTooltip
              [title]="item.label + ' include the total count for bills, manual bills, and adhoc bills'">
            </span> -->
              <div>
                <p class="mb-0 px-1">{{ item.labelAmount }}</p>
                <h4
                  class="mb-0 text-truncate w-9 px-1"
                  kendoTooltip
                  title="{{ item.amount }}"
                >
                  {{ item.amount | currency: "INR" : "symbol" : "1.2-2" }}
                </h4>
              </div>
            </div>
            <div *ngIf="billSummaryLoader" class="chart-loader">
              <div class="spinner"></div>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body" style="width: 100%; overflow: hidden">
            <!--  <span class="info-text required"
              >
             The current date is not included in the consumption data.
            </span> -->
            <div class="d-flex justify-content-between">
              @if (isdailyConsumptionChart) {
                <h4 class="card-title pt-1">
                  <span
                    class="fa fa-info-circle cursor-pointer"
                    title="The current date is not included in the consumption data."
                  ></span
                  >&nbsp; Consumption(Total units consumed:{{
                    consumptionData.length > 0 ? sumOfTotalConsumption : 0
                  }})
                </h4>
              } @else {
                <h4 class="card-title me-3">
                  <span
                    class="fa fa-info-circle cursor-pointer"
                    title=" The current date is not included in the consumption data."
                  ></span
                  >&nbsp; Consumption(Total units consumed:{{
                    monthlyConsumptionchartData.length > 0
                      ? sumOfTotalConsumption
                      : 0
                  }})
                </h4>
              }
              <div class="row">
                <ng-select
                  [items]="projectFilterUtlitys"
                  [clearable]="false"
                  [(ngModel)]="consuptionSelectedUtility"
                  placeholder="Select Utility"
                  (change)="utilitiesChangeConsumption($event)"
                  id="billingType"
                  [multiple]="false"
                  [deselectOnClick]="false"
                  [clearable]="false"
                  bindValue="id"
                  bindLabel="name"
                ></ng-select>
              </div>
            </div>

            @if (isdailyConsumptionChart) {
              <div style="overflow-x: auto">
                <div *ngIf="consumptionLoader" class="chart-loader">
                  <div class="spinner"></div>
                </div>

                <div *ngIf="consumptionData && consumptionData.length > 0">
                  <!-- <apx-chart #chart [series]="chartOptions.series" class="cursor-pointer"
                  style="width: 99%; display: block" [chart]="chartOptions.chart"
                  (dataPointSelection)="onDataPointSelection($event)" [colors]="chartOptions.colors"
                  [yaxis]="chartOptions.yaxis" [dataLabels]="chartOptions.dataLabels" [markers]="chartOptions.markers"
                  [stroke]="chartOptions.stroke" [xaxis]="chartOptions.xaxis" [tooltip]="chartOptions.tooltip || {}"
                  [annotations]="chartOptions.annotations || {}"></apx-chart> -->

                  <apx-chart
                    #chart
                    class="cursor-pointer"
                    [series]="chartOptions.series"
                    [colors]="chartOptions.colors"
                    [chart]="chartOptions.chart"
                    [xaxis]="chartOptions.xaxis"
                    [yaxis]="chartOptions.yaxis"
                    (dataPointSelection)="onDataPointSelection($event)"
                    [dataLabels]="chartOptions.dataLabels"
                    [stroke]="chartOptions.stroke"
                    [markers]="chartOptions.markers"
                    [tooltip]="chartOptions.tooltip"
                    [fill]="chartOptions.fill"
                  >
                  </apx-chart>

                  <div class="d-flex justify-content-end text-danger">
                    <span
                      >*{{
                        consuptionSelectedUtilityType?.name == "Water"
                          ? consuptionSelectedUtilityType?.name + " in Liters"
                          : consuptionSelectedUtilityType?.name == "EB"
                            ? consuptionSelectedUtilityType?.name + " in kWh"
                            : consuptionSelectedUtilityType?.name === "DG"
                              ? consuptionSelectedUtilityType?.name + " in kWh"
                              : consuptionSelectedUtilityType?.name + " in m³"
                      }}
                    </span>
                    <!-- <span>* {{selectedUtility}} units in liters </span> -->
                  </div>
                </div>
              </div>

              <div
                *ngIf="consumptionData && consumptionData.length == 0"
                class="card-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
              >
                <p>No data available</p>
              </div>
            } @else {
              <div *ngIf="monthlyConsumptionLoader" class="chart-loader">
                <div class="spinner"></div>
              </div>
              <div
                *ngIf="
                  monthlyConsumptionchartData &&
                  monthlyConsumptionchartData.length
                "
              >
                <kendo-chart
                  style="height: 264px"
                  (seriesClick)="moreThen3months($event)"
                >
                  <kendo-chart-series>
                    <kendo-chart-category-axis>
                      <kendo-chart-category-axis-item
                        [title]="{ text: 'Months' }"
                      >
                        <!-- X-axis title set to 'Flats' -->
                      </kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>

                    <kendo-chart-value-axis>
                      <kendo-chart-value-axis-item [title]="{ text: 'Units' }">
                        <!-- Y-axis title set to 'Units' -->
                      </kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-series-item
                      [data]="monthlyConsumptionchartData"
                      field="value"
                      categoryField="category"
                      [colorField]="'colorString'"
                      [labels]="{ visible: true, content: labelContent }"
                      [visible]="seriesVisible"
                      [tooltip]="{ visible: true }"
                      [spacing]="1"
                    >
                    </kendo-chart-series-item>
                  </kendo-chart-series>

                  <kendo-chart-legend position="bottom"></kendo-chart-legend>

                  <!-- <kendo-chart-tooltip format="Units">
                  <ng-template kendoChartTooltipTemplate let-tooltip="tooltip">
                    <div>
                      <strong>{{ tooltip.series.name }}</strong><br />
                      Month: {{ tooltip.category }}<br />
                      Value: {{ tooltip.value}}Units
                    </div>
                  </ng-template>
                </kendo-chart-tooltip> -->
                </kendo-chart>

                <div class="d-flex justify-content-end text-danger">
                  <span
                    >*{{
                      consuptionSelectedUtilityType?.name === "Water"
                        ? consuptionSelectedUtilityType?.name + " in Liters"
                        : consuptionSelectedUtilityType?.name === "DG"
                          ? consuptionSelectedUtilityType?.name + " in kWh"
                          : consuptionSelectedUtilityType?.name === "EB"
                            ? consuptionSelectedUtilityType?.name + " in kWh"
                            : consuptionSelectedUtilityType?.name + " in m³"
                    }}</span
                  >
                </div>
              </div>
              <div
                *ngIf="
                  monthlyConsumptionchartData &&
                  monthlyConsumptionchartData.length == 0
                "
                class="card-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
              >
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <!-- <span class="info-text required"
             >
              The current date is not included in the consumption data.
            </span> -->
            <div class="d-flex justify-content-between">
              <h4 class="card-title pt-1" *ngIf="consumptionminmaxvalue == '1'">
                <span
                  class="fa fa-info-circle cursor-pointer"
                  title="The current date is not included in the consumption data."
                ></span
                >&nbsp; Top 5 consumption
              </h4>
              <h4 class="card-title pt-1" *ngIf="consumptionminmaxvalue == '2'">
                <span
                  class="fa fa-info-circle cursor-pointer"
                  title="The current date is not included in the consumption data."
                ></span
                >&nbsp; Least 5 consumption
              </h4>
              <div class="row">
                <div class="col">
                  <ng-select
                    [items]="maxminlist"
                    [(ngModel)]="consumptionminmaxvalue"
                    placeholder="Select Max/Min "
                    class=""
                    (change)="maxMinValucChange($event)"
                    id="billingType"
                    [multiple]="false"
                    [deselectOnClick]="false"
                    [clearable]="false"
                    bindValue="id"
                    bindLabel="name"
                  ></ng-select>
                </div>
                <div class="col">
                  <ng-select
                    [items]="projectFilterUtlitys"
                    [clearable]="false"
                    [(ngModel)]="topconsuptionSelectedUtility"
                    placeholder="Select Utility"
                    (change)="utilitiesChange($event)"
                    id="billingType"
                    [multiple]="false"
                    [deselectOnClick]="false"
                    [clearable]="false"
                    bindValue="id"
                    bindLabel="name"
                  ></ng-select>
                </div>
              </div>
            </div>

            <div *ngIf="topconsumptionLoader" class="chart-loader">
              <div class="spinner"></div>
            </div>

            <div *ngIf="topconsumptionData && topconsumptionData.length > 0">
              <kendo-chart
                style="height: 250px"
                class="mt-3 cursor-pointer"
                (seriesClick)="top5ConsumptionClick($event)"
              >
                <kendo-chart-category-axis>
                  <kendo-chart-category-axis-item [title]="{ text: 'Flats' }">
                  </kendo-chart-category-axis-item>
                </kendo-chart-category-axis>

                <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [title]="{ text: 'Units' }">
                  </kendo-chart-value-axis-item>
                </kendo-chart-value-axis>

                <kendo-chart-series>
                  <kendo-chart-series-item
                    [data]="topconsumptionData"
                    type="bar"
                    field="value"
                    categoryField="category"
                    [labels]="{
                      visible: true,
                      content: labelContent,
                      font: '12px Arial',
                      rotation: -40,
                      padding: -3,
                    }"
                    [colorField]="'colorString'"
                  >
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>

              <div class="d-flex justify-content-end text-danger">
                <span
                  >*{{
                    topconsuptionSelectedUtilityType?.name == "Water"
                      ? topconsuptionSelectedUtilityType?.name + " in Liters"
                      : topconsuptionSelectedUtilityType?.name == "EB"
                        ? topconsuptionSelectedUtilityType?.name + " in kWh"
                        : topconsuptionSelectedUtilityType?.name == "DG"
                          ? topconsuptionSelectedUtilityType?.name + " in kWh"
                          : topconsuptionSelectedUtilityType?.name + " in m³"
                  }}
                </span>
              </div>
            </div>

            <div
              *ngIf="topconsumptionData && topconsumptionData.length == 0"
              class="card-no-data d-flex justify-content-center align-items-center text-center superadminGraph"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <!-- Left col -->
              <div class="col-6">
                <h4 class="card-title mb-0">Communication Status</h4>
              </div>

              <!-- Right col -->
              <div class="col-6 d-flex justify-content-end mb-3">
                <ng-select
                  class="w-100"
                  placeholder="Select utilities"
                 [items]="communicationStatusUtilities"
                  [(ngModel)]="meterUtilityType"
                  (change)="utilityMeterChange($event)"
                  id="billingType"
                  [multiple]="false"
                  [clearable]="false"
                  [deselectOnClick]="false"
                  bindValue="id"
                  bindLabel="name"
                >
                </ng-select>
              </div>
            </div>
            <!-- <div style="margin-top: 38px;"></div> -->
            <!-- Chart Section -->
            <div *ngIf="communicationStatusGraphData.length > 0">
              <kendo-chart
                [style.height.px]="chartHeight"
                class="cursor-pointer"
                [chartArea]="{ margin: { top: 30 } }"
                (seriesClick)="onMeterCommunicationStatusClick($event)"
              >
                <kendo-chart-series>
                  <kendo-chart-value-axis>
                    <kendo-chart-value-axis-item
                      [visible]="false"
                    ></kendo-chart-value-axis-item>
                  </kendo-chart-value-axis>

                  <kendo-chart-series-item
                    [data]="communicationStatusGraphData"
                    field="value"
                    categoryField="category"
                    [colorField]="'colorString'"
                    [labels]="{
                      visible: true,
                      position: 'outsideEnd',
                      padding: 5,
                    }"
                    [tooltip]="{ visible: true }"
                    [spacing]="1"
                  >
                  </kendo-chart-series-item>
                </kendo-chart-series>

                <kendo-chart-category-axis>
                  <kendo-chart-category-axis-item
                    [labels]="{ visible: false }"
                  ></kendo-chart-category-axis-item>
                </kendo-chart-category-axis>

                <kendo-chart-legend position="bottom"></kendo-chart-legend>
              </kendo-chart>

              <div class="my-2">
                <div *ngFor="let series of communicationStatusGraphData">
                  <span
                    ><i
                      class="bx bxs-circle"
                      [ngStyle]="{ color: series.colorString }"
                    ></i>
                    <span class="font-size-12 font-weight-bolder">
                      {{ series?.category }}
                      <span
                        class="fa fa-info-circle cursor-pointer"
                        kendoTooltip
                        [attr.title]="series.comment"
                        [position]="'right'"
                      ></span>
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <!-- No Data -->
            <div
              *ngIf="!meterCommunicationStatus"
              class="meter-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-3">
              <!-- Left col -->
              <div class="col-5">
                <h4 class="card-title mb-0">Meter Status</h4>
              </div>

              <!-- Right col -->
              <div class="col-7 d-flex justify-content-end">
                <ng-select
                  class="w-50"
                  placeholder="Select utilities"
                  [items]="projectUtlityList"
                  placeholder="Select utilities"
                  [(ngModel)]="meterStatusUtility"
                  (change)="MeterStatusUtilityChange($event)"
                  id="billingType"
                  [multiple]="false"
                  [deselectOnClick]="false"
                  bindValue="id"
                  [clearable]="false"
                  bindLabel="name"
                ></ng-select>
              </div>
            </div>

            <!--     <h4 class="card-title mb-0">Meter Status</h4>

            <div class="d-flex justify-content-end mt-2">
              <ng-select class="w-50" placeholder="Select utilities" [items]="projectUtlityList"
                placeholder="Select utilities" [(ngModel)]="meterStatusUtility"
                (change)="MeterStatusUtilityChange($event)" id="billingType" [multiple]="false"
                [deselectOnClick]="false" bindValue="id" [clearable]="false" bindLabel="name"></ng-select>
            </div> -->
            <div
              class="row"
              *ngIf="
                communicationMeterStatusGraphData &&
                communicationMeterStatusGraphData.length > 0
              "
            >
              <kendo-chart
                class="cursor-pointer"
                style="height: 256px"
                (seriesClick)="onMeterStatusClick($event)"
              >
                <kendo-chart-series>
                  <kendo-chart-series-item
                    type="donut"
                    [data]="communicationMeterStatusGraphData"
                  >
                    <kendo-chart-series-item-labels
                      [content]="labelContent"
                      color="#fff"
                      [visible]="true"
                      position="center"
                      background="transparent"
                    >
                    </kendo-chart-series-item-labels>
                  </kendo-chart-series-item>

                  <!-- Optional Tooltip Configuration -->
                  <kendo-chart-tooltip>
                    <ng-template kendoChartTooltipTemplate let-point="point">
                      {{ point.category }}: {{ point.value }} ({{
                        point.percentage
                      }}%)
                    </ng-template>
                  </kendo-chart-tooltip>
                </kendo-chart-series>
              </kendo-chart>

              <div class="d-flex justify-content-between mt-2">
                <div>
                  <div
                    class=""
                    *ngFor="let series of communicationMeterStatusGraphData"
                  >
                    <span class=""
                      ><i
                        class="bx bxs-circle"
                        [ngStyle]="{ color: series.color }"
                      ></i
                      ><span class="font-size-10 font-weight-bolder ms-1">
                        {{ series.name }}</span
                      ></span
                    >
                  </div>
                </div>
              </div>

              <h4 class="card-title mb-0 d-flex justify-content-end">
                Total :
                <span class="font-weight-bolder">
                  {{ totalMeterStatus }}
                </span>
              </h4>
            </div>
            <div
              *ngIf="communicationMeterStatusGraphData.length == 0"
              class="meterSttaus-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-between">
                <h4 class="card-title mb-0">Residential Units</h4>
              </div>
            </div>
            <div
              *ngIf="residentialUnitsData && residentialUnitsData?.length > 0"
            >
              <div
                class="d-flex justify-content-end mt-2"
                style="visibility: hidden"
              >
                <ng-select
                  class="w-50"
                  placeholder="Select utilities"
                  [items]="projectUtlityList"
                  placeholder="Select utilities"
                  id="billingType"
                  [multiple]="false"
                  [deselectOnClick]="false"
                  bindValue="id"
                  [clearable]="false"
                  bindLabel="name"
                ></ng-select>
              </div>
              <kendo-chart
                style="height: 245px"
                class="cursor-pointer"
                (seriesClick)="onResidentialUnitsClick($event)"
              >
                <kendo-chart-series>
                  <kendo-chart-series-item
                    type="pie"
                    [data]="residentialUnitsData"
                  >
                    <kendo-chart-series-item-labels
                      [content]="labelContent"
                      color="#fff"
                      [visible]="true"
                      position="center"
                      background="transparent"
                    >
                    </kendo-chart-series-item-labels>
                  </kendo-chart-series-item>
                  <!-- Optional Tooltip Configuration -->
                  <kendo-chart-tooltip>
                    <ng-template kendoChartTooltipTemplate let-point="point">
                      {{ point.category }}: {{ point.value }} ({{
                        point.percentage
                      }}%)
                    </ng-template>
                  </kendo-chart-tooltip>
                </kendo-chart-series>
              </kendo-chart>
              <div class="d-flex justify-content-between mt-2">
                <div>
                  <div *ngFor="let series of residentialUnitsData">
                    <span class=""
                      ><i
                        class="bx bxs-circle"
                        [ngStyle]="{ color: series.color }"
                      ></i
                      ><span class="font-size-12 font-weight-bolder ms-1">
                        {{ series.name }}
                      </span></span
                    >
                  </div>
                </div>
              </div>
              <h4 class="card-title mb-0 float-end">
                Total :
                <span class="font-weight-bolder">
                  {{ totalResidentialUnits }}
                </span>
              </h4>
            </div>
            <div
              *ngIf="residentialUnitsData && residentialUnitsData.length == 0"
              class="residential-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h4 class="card-title mb-0">Occupied Consumers</h4>
            </div>
            <div *ngIf="consumerData && consumerData.length > 0">
              <div
                class="d-flex justify-content-end mt-2"
                style="visibility: hidden"
              >
                <ng-select
                  class="w-50"
                  placeholder="Select utilities"
                  [items]="projectUtlityList"
                  placeholder="Select utilities"
                  id="billingType"
                  [multiple]="false"
                  [deselectOnClick]="false"
                  bindValue="id"
                  [clearable]="false"
                  bindLabel="name"
                ></ng-select>
              </div>
              <kendo-chart
                style="height: 245px"
                class="cursor-pointer"
                (seriesClick)="onConsumersClick($event)"
              >
                <kendo-chart-series>
                  <kendo-chart-series-item type="pie" [data]="consumerData">
                    <kendo-chart-series-item-labels
                      [content]="labelContent"
                      color="#fff"
                      [visible]="true"
                      position="center"
                      background="transparent"
                    >
                    </kendo-chart-series-item-labels>
                  </kendo-chart-series-item>

                  <!-- Optional Tooltip Configuration -->
                  <kendo-chart-tooltip>
                    <ng-template kendoChartTooltipTemplate let-point="point">
                      {{ point.category }}: {{ point.value }} ({{
                        point.percentage
                      }}%)
                    </ng-template>
                  </kendo-chart-tooltip>
                </kendo-chart-series>
              </kendo-chart>
              <div class="d-flex justify-content-between mt-2">
                <div>
                  <div class="" *ngFor="let series of consumerData">
                    <span class=""
                      ><i
                        class="bx bxs-circle"
                        [ngStyle]="{ color: series.color }"
                      ></i
                      ><span class="font-size-12 font-weight-bolder ms-1">
                        {{ series.name }}
                      </span></span
                    >
                  </div>
                </div>
              </div>
              <h4 class="card-title mb-0 float-end">
                Total :
                <span class="font-weight-bolder"> {{ totalConsumers }} </span>
              </h4>
            </div>
            <div
              *ngIf="consumerData && consumerData.length == 0"
              class="consumer-no-data text-center d-flex justify-content-center align-items-center superadminGraph"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!isDashboardAdmin">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h4 class="card-title mb-0">
                Smart Leak Devices Connection Status
              </h4>
            </div>
            <div *ngIf="deviceCountGrpahData.length > 0">
              <kendo-chart style="height: 203px" class="cursor-pointer">
                <kendo-chart-series>
                  <kendo-chart-series-item
                    type="pie"
                    [data]="deviceCountGrpahData"
                  >
                    <kendo-chart-series-item-labels
                      [content]="labelContent"
                      color="#fff"
                      [visible]="true"
                      position="center"
                      background="transparent"
                      [labels]="{ visible: true, content: labelContent }"
                    >
                    </kendo-chart-series-item-labels>
                  </kendo-chart-series-item>
                  <kendo-chart-tooltip>
                    <ng-template kendoChartTooltipTemplate let-point="point">
                      {{ point.category }}: {{ point.value }} ({{
                        point.percentage
                      }}%)
                    </ng-template>
                  </kendo-chart-tooltip>
                </kendo-chart-series>
              </kendo-chart>
              <div class="d-flex justify-content-between mt-2">
                <div>
                  <div class="" *ngFor="let series of deviceCountGrpahData">
                    <span class=""
                      ><i
                        class="bx bxs-circle"
                        [ngStyle]="{ color: series.color }"
                      ></i
                      ><span class="font-size-12 font-weight-bolder ms-1">
                        {{ series.name }}
                      </span></span
                    >
                  </div>
                </div>
              </div>
              <h4
                class="card-title mb-0 float-end"
                *ngIf="totalDevicecount != 0"
              >
                Total :
                <span class="font-weight-bolder"> {{ totalDevicecount }} </span>
              </h4>
            </div>
            <div
              *ngIf="deviceCountGrpahData && deviceCountGrpahData.length == 0"
              class="text-center d-flex justify-content-center align-items-center device_cont_no_data"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6">
        <div class="card">
          <div class="card-body" style="width: 100%; overflow: hidden">
            <h4 class="card-title pb-1">Leak Detection Identifier</h4>

            <!-- Wrap the text and dropdown in a flex container -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <!--  <p class="text-primary font-size-14 mb-0">Total Notification count {{totalNotificationCount}}
                                  </p> -->
              <div class="col-xl-6">
                <h4 class="text-primary font-size-14 mb-0">
                  Total Notification count:{{ totalNotificationCount }}
                </h4>
              </div>
              <div class="d-flex justify-content-end col-xl-6">
                <div class="d-flex justify-content-between w-200">
                  <div class="ng-select-container ms-auto">
                    <ng-select
                      [items]="LeakmonthsArray"
                      [clearable]="false"
                      [deselectOnClick]="false"
                      placeholder="Select Month"
                      (change)="leakNotificationselectionChange($event)"
                      id="billingType"
                      [(ngModel)]="isSelectMonths"
                      [multiple]="false"
                    ></ng-select>
                  </div>
                </div>
              </div>
            </div>

            @if (isLeakChartShow) {
              <div *ngIf="totalNotificationCount > 0">
                <div style="overflow-x: auto; height: 247px">
                  <div
                    *ngIf="deviceNotificationGraphDataLoding"
                    class="chart-loader"
                  >
                    <div class="spinner"></div>
                  </div>

                  <div
                    *ngIf="
                      deviceNotificationGraphdata &&
                      deviceNotificationGraphdata.length > 0
                    "
                  >
                    <apx-chart
                      #leakchart
                      class="cursor-pointer"
                      [series]="leakchartOptions.series"
                      [colors]="leakchartOptions.colors"
                      [chart]="leakchartOptions.chart"
                      [xaxis]="leakchartOptions.xaxis"
                      [yaxis]="leakchartOptions.yaxis"
                      [dataLabels]="leakchartOptions.dataLabels"
                      [stroke]="leakchartOptions.stroke"
                      [markers]="leakchartOptions.markers"
                      [tooltip]="leakchartOptions.tooltip"
                      [fill]="leakchartOptions.fill"
                    >
                    </apx-chart>
                  </div>
                </div>
              </div>
              <div
                *ngIf="totalNotificationCount == 0"
                class="text-center d-flex justify-content-center align-items-center notification_cont_no_data"
              >
                <p>No data available</p>
              </div>
            } @else {
              <div *ngIf="totalNotificationCount > 0">
                <div
                  *ngIf="devicemonthlyNotificationGraphDataLoding"
                  class="chart-loader"
                >
                  <div class="spinner"></div>
                </div>
                <div
                  *ngIf="
                    monthlydeviceNotificationGraphdata &&
                    monthlydeviceNotificationGraphdata.length
                  "
                >
                  <kendo-chart style="height: 248px">
                    <kendo-chart-series>
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item
                          [title]="{ text: 'Months' }"
                        >
                          <!-- X-axis title set to 'Flats' -->
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>

                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item
                          [title]="{ text: 'Count' }"
                        >
                          <!-- Y-axis title set to 'Units' -->
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
                      <kendo-chart-series-item
                        [data]="monthlydeviceNotificationGraphdata"
                        field="value"
                        categoryField="category"
                        [colorField]="'colorString'"
                        [labels]="{ visible: true, content: labelContent }"
                        [visible]="seriesVisible"
                        [tooltip]="{ visible: true }"
                        [spacing]="1"
                      >
                      </kendo-chart-series-item>
                    </kendo-chart-series>

                    <kendo-chart-legend position="bottom"></kendo-chart-legend>
                  </kendo-chart>
                </div>
              </div>
              <div
                *ngIf="totalNotificationCount == 0"
                class="text-center d-flex justify-content-center align-items-center notification_cont_no_data"
              >
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
